// eslint-disable-next-line
import React from 'react'
import { browserHistory } from 'dva/router';
import dva from 'dva'

import 'whatwg-fetch'

import App from './containers/AppContainer'

const app = dva({
    history: browserHistory,
})

app.model(require('./models/question').default);
app.model(require('./models/app').default);

app.router(() => <App/>);

app.start('#root');




// WEBPACK FOOTER //
// ./src/index.js